import { z } from 'zod'
import { uuidSchema } from '../validators/uuid.validator.js'

/**
 * A user as returned by the authenticated `/users` surface — the roster of
 * people who have access. Deliberately excludes `passwordHash` and anything
 * else non-public; there is a single user type, so there is no role field.
 *
 * Distinct from `AuthUserDto` (in auth.dto.ts), which is the *current* user's
 * identity as carried by the session. This one adds `createdAt` so the team
 * list can show when someone joined.
 */
export const userDtoSchema = z.object({
  id: uuidSchema,
  email: z.string().email(),
  name: z.string(),
  createdAt: z.string().datetime(),
})

export type UserDto = z.infer<typeof userDtoSchema>

export const userListDtoSchema = z.object({
  users: z.array(userDtoSchema),
  total: z.number().int().nonnegative(),
})

export type UserListDto = z.infer<typeof userListDtoSchema>
